
import React, { useState, useCallback, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { MuiThemeProvider } from "@material-ui/core/styles";

// styles
import useStyles,{getMuiTheme} from "./styles";

import { Button, Grid,useTheme } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton } from "@material-ui/core"
import Counter from "./Counter";
import { RelateTile, ProfileTile } from "./Tiles";
import SkeletonShell from "../../../../components/Skeleton/index";

import { get360Data } from "../../../../store/actions/module.actions";
import { pathOr } from "ramda";
import { FaIcon } from '../../../';
import QuickCreate from "../../../../components/DetailView/components/quickCreate/quickCreate";


import Alert from '@material-ui/lab/Alert';

import PropTypes from "prop-types";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
const ResponsiveReactGridLayout = WidthProvider(Responsive);

export default function Customer360({ relData, open, setOpen, setCustomer360Id }) {
  const classes = useStyles();
  const currentTheme = useTheme();
  const { module } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const id = relData.id;
  const name= pathOr(pathOr('', ["attributes", "first_name"], relData)+" "+pathOr('', ["attributes", "last_name"], relData), ["attributes", "name"], relData);
  const [data, setData] = useState([]);
  const [headerButton, setHeaderButton] = useState([]);
  const [counterData, setCounterData] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [relateData, setRelateData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('lg');
  const [currentBreakpoint, setCurrentBreakPoint] = useState('lg');
  const [compactType, setCompactType] = useState('vertical');
  const [mounted, setMounted] = useState(false);
  const [layouts, setLayouts] = useState({ lg: [] });
  const [openQuickCreateDialog, setOpenQuickCreateDialog] = useState(false);
  const [whichQuickCreate, setWhichQuickCreate] = useState(null);
  const [isSubpanelUpdated,setIsSubpanelUpdated] = useState(false);
  const [value,setValue] = useState(0);

  const handleOpenQuickCreateDialog = (action) => {
    if(action.type==='Link'){
      // setOpenQuickCreateDialog(!openQuickCreateDialog);
      // setWhichQuickCreate(action.custom_link_name);
      // window.open("/app/createview/" + action.custom_link_name , "_blank");
      window.open("/app/createrelateview/" + action.r_module+"/"+module+"/"+id+"/"+name , "_blank");
      // history.push("/app/createrelateview/" + action.custom_link_name+"/"+module+"/"+id)
    }else{
      // history.push(action.custom_link);
      if(action.custom_link_name.indexOf("http") > -1){
        window.open(action.custom_link, "_blank");
      }else{
        window.open("http://"+action.custom_link, "_blank");
      }

    }
     
    
  };

  const generateLayout = (newData) => {
    let x = 0;
    return Object.values(newData).map((tile, num) => {
      if (x > 2) {
        x = 0;
      }
      let m = x * 4;
      x++;
      var y = Math.ceil(Math.random() * 4) + 1;
      return {
        x: m,
        y: 4,
        w: 4,
        h: 2,
        i: num.toString(),
        data: tile,
        // static: num === 0 ? true : false
      };

    })
  }


  const loadData = useCallback(() => {
    setLoading(true);
    try {
      dispatch(get360Data(module, id)).then(function (res) {
      
if(res){
        setData(pathOr([], ["Response", "ResponseBody", "Result"], res));
        setHeaderButton(pathOr([], ["Response", "ResponseBody", "Result", "header_button"], res));
        setCounterData(pathOr([], ["Response", "ResponseBody", "Result", "counter"], res));
        let getProfileData=pathOr([], ["Response", "ResponseBody", "Result", "Detail_tile_data"], res);
        let getRelateData = pathOr([], ["Response", "ResponseBody", "Result", "related_module_data"], res).reverse();
      
        let combineData = getProfileData?getRelateData.concat(getProfileData).reverse():getRelateData;
     
        setProfileData(getProfileData);
        setRelateData(getRelateData);
        setLayouts({ lg: generateLayout(combineData) })
        setLoading(false);
     
}else{
  setLoading(false);

}
      })
    } catch (ex) {
      setLoading(false);

    }

  }, [])
  useEffect(
    () => {
      loadData();
    },
    [loadData]);

  const handleClose = () => {
    setOpen(false);
    setCustomer360Id(null);
  };

  const handleMaxWidthChange = (event) => {
    setMaxWidth(event.target.value);
  };

  const handleFullWidthChange = (event) => {
    setFullWidth(event.target.checked);
  };






  const onBreakpointChange = (breakpoint) => {

    setCurrentBreakPoint(breakpoint)
  }

  const onCompactTypeChange = () => {
    const { compactType: oldCompactType } = compactType;
    const compactType =
      oldCompactType === "horizontal"
        ? "vertical"
        : oldCompactType === "vertical"
          ? null
          : "horizontal";
    setCompactType(compactType);
  }

  const onLayoutChange = (layout, layouts) => {
    // onLayoutChange(layout, layouts);
  }

  const onNewLayout = () => {
    setLayouts({ lg: generateLayout() });
  }

  const generateDOM = () => {
    return _.map(layouts.lg, function (l, i) {
      let borderColor= pathOr(currentTheme.palette.primary.main, ["icon", "bgcolor"], l.data);
      let relateModule= pathOr("", ["related_module_name"], l.data);
      return (
        <div key={i} className={classes.tileBox} style={{ borderTop: `${borderColor} solid 3px ` }}>
          {i === 0 && relateModule===""? (
            <ProfileTile data={l.data} pid={id} pmodule={module}/>
          ) : (
            <RelateTile data={l.data} pid={id} pmodule={module} />
          )}
        </div>
      );
    });
  }
  Customer360.propTypes = {
    onLayoutChange: PropTypes.func.isRequired
  };

  Customer360.defaultProps = {
    className: "layout",
    rowHeight: 30,
    onLayoutChange: function () { },
    cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
    // initialLayout: generateLayout()
  };
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
  
<React.Fragment>

      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        
         {loading ? <div style={{ height: '600px' }}><SkeletonShell layout='listView' display /></div> :
        <DialogTitle id="max-width-dialog-title">{data.header_title || <Alert variant="outlined" severity="error">{"You don't have configuration for this module"}<IconButton style={{float:'right'}}  aria-label="close" size="small" onClick={handleClose} color="primary" className={classes.topButtonClose}>
        <CloseIcon  />
      </IconButton></Alert>}
         {data.header_title? <IconButton aria-label="close" size="medium" onClick={handleClose} color="primary" className={classes.topButtonClose}>
            <CloseIcon  />
          </IconButton>:null}
          {headerButton.map((btn) => <Button variant="outlined" size="small" color="primary" style={{ background: btn.color }} className={classes.topButtons}    onClick={() => handleOpenQuickCreateDialog(btn)}>
          <FaIcon icon={`fas ${btn.icon ? btn.icon : "fa-cube"}`} size="1x" />&nbsp;
                             {btn.custom_link_name}
          </Button>)}
        </DialogTitle>}

        <DialogContent>
          {loading ? <div style={{ height: '600px' }}><SkeletonShell layout='listView' display /></div> : <>
          <Grid container
                direction="row"
                justifyContent="center"
                alignItems="left"
              >
                <Grid item xs="12">
            <Counter counterData={counterData} />
            </Grid>
            </Grid>
            <Grid container
                direction="row"
                justifyContent="center"
                alignItems="left"
              >
            <Grid item xs="12">
        
            <div>
         
              <ResponsiveReactGridLayout

                layouts={layouts}
                onBreakpointChange={onBreakpointChange}
                onLayoutChange={onLayoutChange}
                isDraggable={false}
                isResizable={false}
                // WidthProvider option
                measureBeforeMount={false}
                // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
                // and set `measureBeforeMount={true}`.
                useCSSTransforms={mounted}
                compactType={compactType}
                preventCollision={!compactType}
              >

                {generateDOM()}
              </ResponsiveReactGridLayout>
            </div>

            {data.header_title?<Button onClick={handleClose} style={{float:'right'}} variant="outlined" size="small" color="primary" >
              Close
            </Button>:null}
            </Grid>
            </Grid>
            </>}
        </DialogContent>
      </Dialog>
      {openQuickCreateDialog ? <QuickCreate openQuickCreateDialog={openQuickCreateDialog} setOpenQuickCreateDialog={setOpenQuickCreateDialog} whichQuickCreate={whichQuickCreate}  parent_name={name} parent_id={id} parent_type={module} setIsSubpanelUpdated={setIsSubpanelUpdated} setValue={setValue}/> : null}
      {/* parent_name={recordInfo.record_name || ""} parent_id={recordId} parent_type={module} */}
    </React.Fragment>
</MuiThemeProvider>
  );
}


